export default __webpack_public_path__ + "static/media/goto-integrations-horizontal.6cb9c406.svg";